module.exports = __webpack_public_path__ + "static/media/park-origin-24-20-sq-m.bd95b085.jpg";